(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jx-charm-count"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jx-charm-genders')) {
    customElements.define('jx-charm-genders', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.onChange = () => this.updateFields();
        this.onSubmit = (event) => {
          const invalid = Array.from(this.querySelectorAll('select:not(:disabled)')).find(select => !select.value);
          if (invalid) {
            event.preventDefault();
            event.stopImmediatePropagation();
            invalid.focus();
            invalid.reportValidity();
          }
        };
        this.form.addEventListener('change', this.onChange);
        this.form.addEventListener('submit', this.onSubmit, true);
        this.updateFields();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change', this.onChange);
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }
      updateFields() {
        const variantId = this.form.querySelector('input[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === variantId);
        const count = variant?.count || 1;
        this.querySelectorAll('[data-charm-row]').forEach(row => {
          const active = Number(row.dataset.charmRow) <= count;
          row.hidden = !active;
          const select = row.querySelector('select');
          select.disabled = !active;
          row.querySelectorAll('[data-color-preview]').forEach(preview => {
            preview.hidden = !active || select.value !== preview.dataset.previewOption;
          });
        });
        const complete = Array.from(this.querySelectorAll('select:not(:disabled)')).every(select => select.value);
        this.toggleAttribute('data-complete', complete);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jx-mobile-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jx-mobile-buy')) {
    customElements.define('jx-mobile-buy', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.bar = this.querySelector('.jx-mobile-buy__bar');
        this.button = this.querySelector('button');
        this.price = this.querySelector('.jx-mobile-buy__price');
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.media = window.matchMedia('(max-width: 749px)');
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.onClick = () => {
          const invalid = this.getInvalidControl();
          if (invalid) {
            invalid.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            invalid.focus({ preventScroll: true });
            return;
          }
          const original = this.form.querySelector('button[name="add"]');
          if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') this.form.requestSubmit(original);
        };
        this.button.addEventListener('click', this.onClick);
        this.form.addEventListener('change', this.queue);
        this.form.addEventListener('input', this.queue);
        window.addEventListener('scroll', this.queue, { passive: true });
        window.addEventListener('resize', this.queue);
        this.observer = new MutationObserver(this.queue);
        this.observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open', 'disabled', 'aria-disabled'] });
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
        this.form?.removeEventListener('change', this.queue);
        this.form?.removeEventListener('input', this.queue);
        window.removeEventListener('scroll', this.queue);
        window.removeEventListener('resize', this.queue);
        if (this.frame) cancelAnimationFrame(this.frame);
      }
      getInvalidControl() {
        return Array.from(this.form.elements).find(control => control.willValidate && !control.validity.valid);
      }
      update() {
        const original = this.form.querySelector('button[name="add"]');
        const variantId = this.form.querySelector('input[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === variantId);
        const overlay = document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], .product-media-modal[open], details-modal details[open], menu-drawer details[open], .jx-mobile-menu[open]');
        const visible = !!(this.media.matches && original && original.getBoundingClientRect().bottom < 0 && !overlay);
        this.bar.hidden = !visible;
        this.toggleAttribute('data-visible', visible);
        const price = variant?.price || '';
        if (this.price.textContent !== price) this.price.textContent = price;
        const busy = original?.getAttribute('aria-disabled') === 'true' || original?.classList.contains('loading');
        this.button.disabled = !variant?.available || !!original?.disabled || !!busy;
        const label = !variant ? this.dataset.unavailable : !variant.available ? this.dataset.soldOut : busy ? this.dataset.loading : this.getInvalidControl() ? this.dataset.personalize : this.dataset.add;
        if (this.button.textContent !== label) this.button.textContent = label;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
